import { requestService, BehaviorSubject, cookies } from '@contorion/core';

export const SEARCH_URL = '/s/bar';

export class SearchService {
    public value: BehaviorSubject<string>;
    public category: BehaviorSubject<string>;
    public result: BehaviorSubject<string>;
    public keyboardEvent: BehaviorSubject<KeyboardEvent>;
    protected timeout: number;

    constructor() {
        this.category = new BehaviorSubject('');
        this.value = new BehaviorSubject('');
        this.result = new BehaviorSubject('');
        this.keyboardEvent = new BehaviorSubject(null);
    }

    public search() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }

        this.timeout = window.setTimeout(this.doSearch.bind(this), 300);
    }

    protected doSearch() {
        const value = this.value.getValue();
        const category = this.category.getValue();
        const body = new FormData();
        body.append('c', category);
        body.append('q', value);

        requestService.post(SEARCH_URL, body)
            .then((response) => {
                return response?.text();
            })
            .then((result) => {
                this.result.next(result);
            });
    }
}
